// extracted by mini-css-extract-plugin
module.exports = {"specials_tab":"SpecialsTab_specials_tab__tyQu4","specials_list":"SpecialsTab_specials_list__CIB1Z"};